<template>
  <el-tabs v-model="activeName" @tab-click="handleClick">
    <el-tab-pane label="套餐记录" name="tc">
    <signStatistics></signStatistics>
    </el-tab-pane>
    <el-tab-pane label="积分记录" name="jf">
    <score></score>
    </el-tab-pane>
  </el-tabs>
</template>
<script>
import Score from './score.vue';
import signStatistics from './signStatistics'
  export default {
      components:{signStatistics,Score},
    data() {
      return {
        activeName: 'tc'
      };
    },
    created(){
      let a = this.$route.query.type;
      this.activeName = a ? a : "tc"
    },
    methods: {
      handleClick(tab, event) {
        console.log(tab, event);
      }
    }
  };
</script>
<style lang="less" scoped>
/deep/ .el-tabs__item.is-active{
    color:#EC1C1C
}

/deep/ .el-tabs__active-bar{
    background-color: #EC1C1C;
}

/deep/ .el-tabs__item:hover{
    color: #EC1C1C;
}

/deep/ .el-tabs__nav{
        transform: translateX(20px) !important;
}
</style>


// WEBPACK FOOTER //
// pages/tpl/costStatistics.vue